<template>

  <MembershipBannerBar v-if="!userStore.isFullMember()">
    Full members see progression rings for <i>all</i> ceremonies.
  </MembershipBannerBar>

  <div class="container mol-typical-page-container-10" :class="{'showing-message-banner': !userStore.isFullMember()}">
    <LoadingSpinner v-if="!ceremonyOverview" class="text-secondary" loading_text="loading" style="margin-top: 50px;"></LoadingSpinner>

    <!-- members   -->
    <div v-else-if="userStore.isFullMember()">
      <!-- each ceremony -->
      <CeremonyCard v-for="(ceremony_info, index) in ceremonyOverview"
                    :key="index"
                    :ceremony_info="ceremony_info"
                    :hide_bottom_border="index === (ceremonyOverview.length-1)"
                    :only_show_expanded="$screenshotMode"
      ></CeremonyCard>
    </div>

    <!-- non-members   -->
    <div v-else>

      <!-- show top ceremony      -->
      <CeremonyCard
          :ceremony_info="ceremonyOverview[0]"
          :only_show_expanded="true"
      ></CeremonyCard>

      <!-- position checklist message      -->
      <div class="mol-center-card-width non-member-checklist-card">
        Although only full members see their <i>progression rings</i> for previous ceremonies, all users can access all {{ceremonyOverview[0].ceremony}} ceremonies on the
        <router-link to="/checklist">Checklists Page</router-link>.
      </div>

      <!-- show a couple disabled ceremonies, fading out      -->
      <CeremonyCard
        v-if="ceremonyOverview.length > 1"
        :ceremony_info="ceremonyOverview[1]"
        :only_show_expanded="true"
        :disabled="true"
        style="opacity: 0.5;"
      ></CeremonyCard>

      <CeremonyCard
          v-if="ceremonyOverview.length > 2"
          :ceremony_info="ceremonyOverview[2]"
          :only_show_expanded="true"
          :disabled="true"
          style="opacity: 0.5;"
      ></CeremonyCard>

    </div>

  </div>

</template>

<script>


import axios from "axios";
import {userStore} from "@/userStore";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import CeremonyCard from "@/components/dashboard/CeremonyCard.vue";
import analytics from "@/analytics";
// eslint-disable-next-line
import MembershipBannerBar from "@/components/MembershipBannerBar.vue";

export default {
  name: "DashboardPage",
  components: {
    // eslint-disable-next-line
    MembershipBannerBar,
    CeremonyCard,
    LoadingSpinner,
  },
  computed: {
    userStore() {
      return userStore;
    }
  },
  data() {
    return {
      ceremonyOverview: null
    }
  },
  async created() {
    axios.get('/api/ceremony/overview')
        .then((result) => {

          /*
          This API response contains data for multiple award ceremonies, each with:
          - 'ceremony': The ceremony number.
          - 'years': The range of years covered by the ceremony.
          - 'nomination_summary': An array of award categories, each with:
             - 'category': The category object for this nomination.
             - 'films': An array of films nominated in that category, each containing:
               - 'film_id': Unique identifier for the film.
               - 'won': Boolean indicating whether the film won the award in that category.
               - 'unofficial_nom': aadb doesn't consider this an official nomination
          */

          this.ceremonyOverview = result.data;
          //console.log(`ceremonyOverview`, this.ceremonyOverview);

          // put most recent ceremonies first
          this.ceremonyOverview.sort((cer1, cer2) => {
            return (cer1.ceremony < cer2.ceremony)? 1 : (cer1.ceremony > cer2.ceremony)? -1 : 0;
          });


          this.ceremonyOverview.forEach(ceremonyOverview => {
            // add 'film_ids' accessor to each ceremony, returning a list of unique film ids
            Object.defineProperty(ceremonyOverview, 'film_ids', {
              get: function() {
                const filmIdArray = this.nomination_summary.reduce((accFilmIds, curNom) => {
                  return [...accFilmIds, ...curNom.films.map(f => f.film_id)];
                }, []);

                return [ ...new Set(filmIdArray) ];
              }
            });
            // add 'film_ids_contributing_to_percentage' accessor to each ceremony, a filtered version of film_ids that
            //  excludes any film with no official nominations
            Object.defineProperty(ceremonyOverview, 'film_ids_contributing_to_percentage', {
              get: function() {
                return this.film_ids.filter(film_id => {
                  return this.nomination_summary.some(nom => nom.films.some(film => {
                    return ( film.film_id === film_id ) && !film.unofficial_nom;
                  }));
                });
              }
            });
          });

          if ( !userStore.isFullMember() ) {
            this.ceremonyOverview.length = Math.min(this.ceremonyOverview.length, 3);
          }
          //console.log(this.ceremonyOverview);
        })

        .catch((err) => {
          analytics.notifyBugsnagOfError(err);
        });
  },
  methods: {

    firstHalfOfArray(_array) {
      const half = Math.ceil(_array.length / 2)
      return _array.slice(0, half);
    },

    secondHalfOfArray(_array) {
      const half = Math.ceil(_array.length / 2)
      return _array.slice(half);
    },

  }
}
</script>


<style scoped>

.mol-typical-page-container-10 {
  &.showing-message-banner {
    max-height: 1250px;
    overflow: hidden;
  }
}

.non-member-checklist-card {

  position: absolute;
  z-index: 1;


  left: 50%;          /* Moves the left edge to the horizontal center of the parent */
  transform: translate(-50%, 80px); /* Shifts the element back by half its own width and height */


  width: 90%;
  max-width: 450px;
  border: solid;
  border-width: 0.1px;
  border-radius: 10px;
  border-color: var(--bs-card-border-color);

  box-shadow: 0 3px 10px -5px grey;

  padding: 1em;
  text-align: center;
  color: var(--bs-secondary);
  background-color: var(--bs-body-bg);

  a {
    white-space: nowrap;
    color: inherit;
    font-weight: 500;

    .fa-external-link {
      margin-left: 0.2em;
    }

    &:hover {
      color: var(--bs-link-hover-color);
    }
  }
}


</style>